import React from "react";
import { MdDelete, MdEdit } from "react-icons/md";
import { IProduct } from "../../interfaces/product";
import { deleteProduct } from "../../services/product.service";
import { useError } from "../../store/ErrorModal";
import ModalConfirmation from "../common/ModalConfirmation";
import parse from "html-react-parser";
import {
  BubleEdit,
  CardContent,
  CardProduct,
  Descriptions,
  Detail,
  HeaderTitleCard,
  ReadMoreButton,
  TypeProduct,
} from "./CardProductComponent.style";
import ModalEditProduct from "./ModalEditProduct";

export default function CardProductComponent({
  item,
  fetchData,
}: {
  item: IProduct;
  fetchData: () => void;
}) {
  const [showMore, setShowMore] = React.useState<boolean>(false);
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [isOpenDelete, setIsOpenDelete] = React.useState<boolean>(false);
  const { onError } = useError();
  const handleDelete = async () => {
    try {
      await deleteProduct(item.productId);
      setIsOpenDelete(false);
      fetchData();
    } catch (error) {
      onError(error as any);
    }
  };
  return (
    <CardProduct bgImage={item.imageUrl}>
      <BubleEdit onClick={() => setIsOpen(true)}>
        <MdEdit size={22} color="#555" />
      </BubleEdit>
      <BubleEdit
        style={{ right: "3.25rem" }}
        onClick={() => setIsOpenDelete(true)}
      >
        <MdDelete size={22} color="#555" />
      </BubleEdit>
      <TypeProduct>
        {item.type[0].toUpperCase() + item.type.slice(1)}
      </TypeProduct>
      <CardContent>
        <HeaderTitleCard showMore={showMore}>
          {item.productName}
        </HeaderTitleCard>
        <Descriptions showMore={showMore}>
          {parse(item.productDescription || "")}
        </Descriptions>
        <ReadMoreButton onClick={() => setShowMore(!showMore)}>
          {showMore ? "แสดงน้อยลง" : "เพิ่มเติม"}
        </ReadMoreButton>
        <Detail>
          <span>ราคา:</span> {item.price} บาท{"  "}
          {item.type === "product" ? (
            <>{/* <span>จำนวนคงเหลือ:</span> {item.amount} ชิ้น */}</>
          ) : item.type === "chat" ? (
            <>
              {item.dayRange && (
                <>
                  <span>ระยะเวลา:</span> {item.dayRange} วัน
                </>
              )}
            </>
          ) : (
            <>
              {item.timeRange && (
                <>
                  <span>ระยะเวลา:</span> {item.timeRange} นาที
                </>
              )}
            </>
          )}
        </Detail>
      </CardContent>
      <ModalEditProduct
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        fetchData={() => {}}
        oldData={item}
      />
      <ModalConfirmation
        isOpen={isOpenDelete}
        onConfirm={handleDelete}
        onCancel={() => setIsOpenDelete(false)}
        title={"ยืนยันการลบ"}
        description={`ยืนยันการลบ ${item.productName}`}
      />
    </CardProduct>
  );
}
